import { render, staticRenderFns } from "./canWithdraw.vue?vue&type=template&id=ddf11332&scoped=true"
import script from "./canWithdraw.vue?vue&type=script&lang=js"
export * from "./canWithdraw.vue?vue&type=script&lang=js"
import style0 from "./canWithdraw.vue?vue&type=style&index=0&id=ddf11332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf11332",
  null
  
)

export default component.exports